export const officeConstants = {
    OFFICE_LOADING: 'OFFICE_LOADING',
    GETOFFICE_SUCCESS: 'GET_OFFICE_SUCCESS',
    GETOFFICE_FAILURE: 'GET_OFFICE_FAILURE',
    PUTOFFICE_SUCCESS: 'PUT_OFFICE_SUCCESS',
    PUTOFFICE_FAILURE: 'PUT_OFFICE_FAILURE',
}
